<template>
  <div class="col-span-12 md:col-span-6 lg:col-span-3">
    <div
      class="bg-surface-0 dark:bg-surface-900 shadow-md p-4 rounded-md bg-white"
    >
      <div class="flex justify-between mb-3">
        <div>
          <span
            class="block text-surface-500 dark:text-surface-300 font-medium mb-3"
          >Transport Bookings</span>
          <div
            class="text-surface-900 dark:text-surface-0 font-medium !text-xl"
          >
            <b>{{ confirmed }}</b>
          </div>
        </div>
        <div
          class="flex items-center justify-center bg-pink-100 dark:bg-pink-400/30 rounded-md icon"
        >
          <i
            class="pi pi-truck text-pink-500 dark:text-pink-200 !text-xl"
          />
        </div>
      </div>
      <span class="text-green-500 font-medium">{{ notConfirmed }}</span>
      <span class="text-surface-500 dark:text-surface-300">
        unconfirmed</span>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
const confirmed = ref(6);
const notConfirmed = ref(12);
</script>

<style scoped>
.icon {
    width: 40px;
    height: 40px;
}
</style>
